import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 20px;
`;

const StyledTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	cursor: pointer;
	transition:
		background 0.3s ease,
		border-color 0.3s ease;

	.img-icon {
		transition: background-color 0.3s ease;
	}

	&:hover {
		background: #ffffff;
		border-color: #ffffff;

		.img-icon {
			background-color: #000000;
		}
	}
`;

export { StyledCloseButton, StyledContainer, StyledTitle };
